<script>
import resources from './resources'

export default {
  name: 'my-address',
  mixins: [resources]
}
</script>

<template lang="pug">
  .white-bg.list-item
    .row.border-bottom
      h4.col-xs-7
        i.fa.fa-check-circle(v-if="address.correspondence === true")
        |  {{ address.label }}
      .col-xs-5
        .exclude-list(@click.prevent="$emit('on-delete', address)")
          span.icon 
        router-link(:to="{name: 'settings.addresses.edit', params: {id: address.id}}")
          .edit-list
            span.icon 
    .list-info
      | {{ address.street }}, {{ address.number }}
      br
      | {{ address.district }} — {{ address.city }} — {{ address.state }}
</template>



// WEBPACK FOOTER //
// src/app/settings/addresses/index/components/address.vue